import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=3e6db103&scoped=true&"
var script = {}
import style0 from "./MainContent.vue?vue&type=style&index=0&id=3e6db103&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6db103",
  null
  
)

export default component.exports